import { Box } from "@mui/material";

const MyYoutube = ({ embedId, width, height, title }) => {
    return (
        <Box sx={{

        }}>
        <iframe
            width={width}
            height={height}
            src={`https://www.youtube.com/embed/${embedId}`}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            title={title}
        />
        </Box>
    )
};

export default MyYoutube;